import axios from 'axios'
import { API_BASE_URL } from '../globalVar'

let baseUrl = API_BASE_URL
//let baseUrl = process.env.VUE_APP_API_BASE_URL

export const salesApiService = {
    getDocumentsForQuote,
    tigaQuoteSearch
}

function getDocumentsForQuote(payload) {
    return axios.get(baseUrl + '/api/admin/v1/document/sales/getforquote/' + payload)
}

function tigaQuoteSearch(travelPolicyId) {
    let params = { travelPolicyId }
    return axios.post(baseUrl + '/api/admin/v1/policy/searchtiga/', params)
}



